// Module
var code = "<span class=\"tc-icon\" :class=\"classes\" :style=\"style\"></span>\n";
// Exports
export default code;